/* U1 — estado de stock visible en las cards de accesorios de la PDP.
 *
 * Problema: el Liquid marca "Sold out" solo si la variante que resolvio al
 * renderizar esta agotada. Cuando el accesorio tiene colores (ej. Water Bottle:
 * solo Stone Gray con stock) la card se veia normal y el cliente recien se
 * enteraba al tocarla, con el toast "Out of stock".
 *
 * Este script mira el JSON de accesorios que ya emite la seccion
 * ([data-u1-pdp-accessories], con todas las variantes y su available) y:
 *   · tacha los swatches de color sin stock (.is-disabled, estilo ya existente),
 *   · marca la card como .is-soldout y reemplaza el precio por "Sold out" cuando
 *     la variante seleccionada (o la unica posible) no tiene stock.
 *
 * Solo visual: el bloqueo del add ya lo hace el customizer. Vive en assets/ por el
 * limite de 256KB de snippets.
 */
(function () {
  var SOLD_OUT_HTML = '<span class="u1-pdp-card__price u1-text-body-xs u1-pdp-card__price--soldout">' + U1S.sold_out + '</span>';

  function parseVid(raw) {
    var s = (raw || '').toString().trim();
    if (!s) return 0;
    var m = s.match(/(\d{6,})/g);
    return m ? Number(m[m.length - 1]) || 0 : 0;
  }

  function readCatalog(root) {
    if (root._u1StockCat) return root._u1StockCat;
    var byId = Object.create(null);
    var byHandle = Object.create(null);
    try {
      var el = root.querySelector('[data-u1-pdp-accessories]');
      var list = el ? JSON.parse(el.textContent || '[]') : [];
      (list || []).forEach(function (p) {
        if (!p || !p.handle) return;
        var vs = Array.isArray(p.variants) ? p.variants : [];
        byHandle[p.handle] = vs;
        vs.forEach(function (v) { if (v && v.id) byId[Number(v.id)] = v; });
      });
    } catch (_e) {}
    root._u1StockCat = { byId: byId, byHandle: byHandle };
    return root._u1StockCat;
  }

  function apply(card, soldOut) {
    card.classList.toggle('is-soldout', soldOut);
    var row = card.querySelector('[data-u1-pdp-card-price-row]');
    /* Si la card esta "Included" en un bundle el price row va oculto: no tocarlo */
    if (!row || row.style.display === 'none') return;
    if (soldOut) {
      if (!row._u1StockOrig) row._u1StockOrig = row.innerHTML;
      if (row.getAttribute('data-u1-stock-soldout') !== '1') {
        row.innerHTML = SOLD_OUT_HTML;
        row.setAttribute('data-u1-stock-soldout', '1');
      }
    } else if (row.getAttribute('data-u1-stock-soldout') === '1') {
      if (row._u1StockOrig) row.innerHTML = row._u1StockOrig;
      row.removeAttribute('data-u1-stock-soldout');
    }
  }

  function syncRoot(root) {
    var cat = readCatalog(root);
    var cards = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
    cards.forEach(function (card) {
      try {
        var handle = card.getAttribute('data-u1-pdp-accessory-handle') || '';
        var vs = handle ? (cat.byHandle[handle] || null) : null;
        if (!vs || !vs.length) return;

        /* Swatches del propio card (viven al lado del boton, en .u1-pdp-card-hit) */
        var hit = card.closest('.u1-pdp-card-hit') || card.parentElement;
        var swatches = hit ? Array.from(hit.querySelectorAll('[data-u1-pdp-card-color-swatch]')) : [];
        var selectedVid = 0;
        swatches.forEach(function (sw) {
          var vid = parseVid(sw.getAttribute('data-u1-pdp-card-color-swatch-variant-id'));
          var v = vid ? cat.byId[vid] : null;
          var oos = !!(v && v.available === false);
          sw.classList.toggle('is-disabled', oos);
          if (sw.classList.contains('is-selected')) selectedVid = vid;
        });

        /* Misma resolucion que el customizer al agregar al carrito: swatch elegido →
           variante fija → primera variante. Si la card depende del talle o de un
           filtro (style/helmet) no se adivina: solo se marca si TODO esta agotado. */
        var vid2 = selectedVid || parseVid(card.getAttribute('data-u1-pdp-accessory-variant-id'));
        var dyn = card.getAttribute('data-u1-pdp-accessory-sync-size') === 'true'
          || card.hasAttribute('data-u1-pdp-accessory-filter-style')
          || card.hasAttribute('data-u1-pdp-accessory-filter-helmet');
        var variant = vid2 ? cat.byId[vid2] : (dyn ? null : vs[0]);
        var soldOut;
        if (variant) soldOut = variant.available === false;
        else soldOut = !vs.some(function (v) { return v && v.available !== false; });
        apply(card, soldOut);
      } catch (_e) {}
    });
  }

  function syncAll() {
    Array.from(document.querySelectorAll('.u1-pdp-customizer')).forEach(function (root) {
      try { syncRoot(root); } catch (_e) {}
    });
  }
  window.u1SyncStockBadges = syncAll;

  var t = null;
  function schedule(ms) {
    if (t) window.clearTimeout(t);
    t = window.setTimeout(syncAll, ms || 80);
  }

  /* Cambios de color del accesorio, de pack o de seleccion del customizer */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-u1-pdp-card-color-swatch], [data-u1-pdp-bundle-card], [data-u1-pdp-accessory]') : null;
    if (el) schedule(120);
  }, true);
  window.addEventListener('u1:pdp:selection', function () { schedule(120); });
  document.addEventListener('u1:pdp:pack-change', function () { schedule(200); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(300); });
  } else {
    schedule(200);
  }
  [900, 2500].forEach(function (ms) { window.setTimeout(syncAll, ms); });
})();
